import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';
import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import Slide from '@zenbusiness/zui/Slide';
import WistiaPlayer from '@zenbusiness/zui/WistiaPlayer';

import * as Styled from './WebinarDialog.styles';

const SlideUpTransition = forwardRef((props, ref) => <Slide ref={ref} direction="up" {...props} />);

function WebinarDialog({ title, videoId, onClose }) {
  return (
    <Styled.Root fullScreen open TransitionComponent={SlideUpTransition}>
      <Styled.Content>
        <Styled.Header>
          <Box sx={{ flexGrow: 1 }}>
            <Styled.Title>{title}</Styled.Title>
          </Box>
          <IconButton icon={<CloseIcon />} label="Close" onClick={onClose} sx={{ color: 'inherit' }} />
        </Styled.Header>
        <Styled.Body>
          <WistiaPlayer videoId={videoId} clickstreamProps={{ videoName: title }} />
        </Styled.Body>
      </Styled.Content>
    </Styled.Root>
  );
}

WebinarDialog.propTypes = {
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WebinarDialog;
